module.exports = __webpack_public_path__ + "static/Hans-dbc36b1a2d430271d9085e375f8f945f.png";